import { Chip, Tooltip } from '@mui/material'
import { isEmpty } from 'lodash'
import { FC } from 'react'
import { ReplyCitationDTO } from '../../../../swagger/dto'
import Citation from './Citation'

interface Props {
    citations: ReplyCitationDTO[]
    index?: number
}

const Footnote: FC<Props> = ({ citations = [], index = 0 }) => {
    const citation = !isEmpty(citations) ? citations[index - 1] : null

    if (!citation) {
        return null
    }

    return (
        <Tooltip
            enterTouchDelay={0}
            leaveTouchDelay={3000}
            slotProps={{
                tooltip: {
                    sx: {
                        padding: '0',
                        borderRadius: '16px',
                        backgroundColor: '#FFFFFF',
                    },
                },
            }}
            title={<Citation citation={citation} index={index-1} />}>
            <Chip
                size="small"
                sx={{
                    '& .MuiChip-label': {
                        marginRight: '0',
                    },
                }}
                label={index}
            />
        </Tooltip>
    )
}

export default Footnote
